import React, { useEffect, useState } from 'react';
import { Box, VStack, Text, Select, Input, Button, useToast } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import { listOwnerSeries, addEpisodeToSeries, type SeriesDoc } from '../services/contentService';
import { uploadFileDirect } from '../services/uploadService';

const AddEpisode: React.FC = () => {
  const { user } = useAuth();
  const toast = useToast();
  const [seriesId, setSeriesId] = useState('');
  const [title, setTitle] = useState('');
  const [episodeNumber, setEpisodeNumber] = useState<number>(1);
  const [file, setFile] = useState<File | null>(null);
  const [options, setOptions] = useState<{ id: string; title: string }[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user) return;
    listOwnerSeries(user.uid).then((list: SeriesDoc[]) => setOptions(list.map((s: SeriesDoc) => ({ id: s.id!, title: s.title }))));
  }, [user]);

  const handleSave = async () => {
    if (!user) { toast({ title: 'Please sign in', status: 'warning' }); return; }
    if (!seriesId || !file || !title) { toast({ title: 'Fill all fields', status: 'warning' }); return; }
    setSaving(true);
    try {
      const assetUrl = await uploadFileDirect(`users/${user.uid}/episodes/${seriesId}`, file);
      await addEpisodeToSeries(seriesId, { 
        title, 
        episodeNumber, 
        description: '', 
        videoUrl: assetUrl, 
        thumbnail: '', 
        duration: 0, 
        seasonNumber: 0 
      });
      toast({ title: 'Episode added', status: 'success' });
      setTitle(''); setEpisodeNumber(1); setFile(null); setSeriesId('');
    } catch (e: any) {
      toast({ title: 'Failed to add episode', description: e.message, status: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box maxW="600px" mx="auto" p={6}>
      <VStack align="stretch" gap={4}>
        <Text fontSize="2xl" fontWeight="bold">Add Episode to Series</Text>
        <Select placeholder="Select series" value={seriesId} onChange={(e) => setSeriesId(e.target.value)}>
          {options.map(o => <option key={o.id} value={o.id}>{o.title}</option>)}
        </Select>
        <Input placeholder="Episode title" value={title} onChange={(e) => setTitle(e.target.value)} />
        <Input type="number" placeholder="Episode number" value={episodeNumber} onChange={(e) => setEpisodeNumber(parseInt(e.target.value || '1', 10))} />
        <Input type="file" accept="video/*" onChange={(e) => setFile(e.target.files?.[0] || null)} />
        <Button colorScheme="purple" onClick={handleSave} isLoading={saving}>Add Episode</Button>
      </VStack>
    </Box>
  );
};

export default AddEpisode;



